import tripEvents from './../../config/events.constant';
import tripStatuses from './../../trip-statuses';
import tripItemTypes from './../../trip-item-types';

export default function TripCheckoutAvailabilityController(
    $scope,
    $rootScope,
    $stateParams,
    $state,
    tripId,
    tripFactory,
    tripAPI,
    tripData,
    flightsUtils,
    railsUtils,
    supplierService,
    TRIP_ELEMENTS_TYPES_MAP,
    TRIP_STATES_MAP
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
        checkTripAvailability,
        tripItemTypes,
    });

    function $onInit() {
        initScope();
    }

    function initScope() {
        $scope.hasUnavailableProducts = false;
        $scope.changedPrices = false;
        $scope.heldProducts = false;
        $scope.showWarning = false;
        $scope.radioChoice = '1';

        /**
         * Handler for 'Cancel' button
         */
        $scope.cancel = function() {
            $scope.showWarning = false;
        };

        $scope.continue = function(choice) {
            const requestData = {
                CheckTripAvailabilityResponseId: $scope.CheckTripAvailabilityResponseId,
                Choice: choice,
            };
            tripAPI.updateInvalidTrip(requestData).then(
                function() {

                    /**
                     * Remove Unavailable Items
                     */
                    if (choice === '1') {
                        if ($scope.allProductsAreUnavailable) {
                            changeState();
                            $scope.cancel();
                        } else {
                            tripFactory.tripDetails(tripId).then(
                                function(response) {
                                    $rootScope.$broadcast(tripEvents.TRIP_REFRESH_ITINERARY, response);
                                    proceed();
                                }
                            );
                        }
                    }

                    /**
                     * No Changes
                     * Search again
                     */
                    if (choice === '0') {
                        changeState();
                        $scope.cancel();
                    }

                    /**
                     * Release all held products
                     */
                    if (choice === '2') {
                        changeState();
                        $scope.cancel();
                    }
                }
            );
        };

        $scope.$on(tripEvents.TRIP_CHECK_AVAILABILITY, checkTripAvailabilityAndGoNext);

        /**
         * Hide warning if 'Hold' button pressed
         */
        $scope.$on(tripEvents.TRIP_START_HOLD, function() {
                $scope.showWarning = false;
            });

        activate();
    }

    function activate() {
        goDirectlyToBook();
    }

    function goDirectlyToBook() {
        if ($scope.tripData.IsBookSectionOpen) {
            goToBook(null, 'Book');
        }
    }

    function goToBook() {
        $scope.nextStep = 'Book';
        proceed();
    }

    function checkTripAvailabilityAndGoNext(event, arg) {
        $scope.nextStep = arg;
        checkTripAvailability(arg);
    }

    function getElement(id, type) {
        const tripItemType = TRIP_ELEMENTS_TYPES_MAP[type];
        return _.findWhere($scope.tripDetails[tripItemType], {Id: +id});
    }

    function normalizeTripProductsAndSeats(products, seats) {
        return [
            ...products.map((product) => ({
                    ...product,
                    ...getElement(product.TripItemId, product.TripItemType),
                })),
            ...seats.map((seat) => ({
                    TripItemType: tripItemTypes.seat,
                    ...seat,
                }
            )),
        ];
    }

    /**
     * Check if trip elements are still available before booking or holding
     */
    function checkTripAvailability() {
        if ($scope.tripDetails.IsOfflineTrip) {
            proceed();
            return;
        }

        tripAPI.checkTripAvailability(tripId)
            .then(({data}) => { // eslint-disable-line
                $scope.avlblData = data;

                const priceChangedSeats = data.PriceChangedSeats || [];
                const unavailableSeats = data.UnavailableSeats || [];
                const unavailableSeatsAmount = unavailableSeats.length;

                vm.priceChangedItems = normalizeTripProductsAndSeats(data.PriceChangedProducts, priceChangedSeats);
                vm.unavailableItems = normalizeTripProductsAndSeats(data.UnavailableProducts, unavailableSeats);

                $scope.CheckTripAvailabilityResponseId = $scope.avlblData.CheckTripAvailabilityResponseId;
                $scope.heldProducts = tripHasHeldProducts($scope.tripDetails);
                vm.heldProductsPriceChanged = tripHasHeldProductsWithPriceChanged($scope.tripDetails, data.PriceChangedProducts);
                $scope.unavailableProductsAmount = $scope.avlblData.UnavailableProducts.length;
                $scope.hasUnavailableProducts = !!$scope.unavailableProductsAmount || !!unavailableSeatsAmount;
                $scope.allProductsAreUnavailable = checkIfAllProductsAreUnavailable();
                $scope.onlySeatsChangedPrice = onlySeatsPriceWasChanged();
                //passing `isAvailable` flag to tripCheckoutLuggageController to hide luggage if all flights are unavailable
                tripData.isAvailable = !allFlightsAreUnavailable(data.UnavailableProducts);
                if (!$scope.tripData.IsApproved) {
                    $scope.allProductsPriceChanged = checkIfallProductsPriceChanged();
                    $scope.allProductsChanged = $scope.allProductsAreUnavailable || ($scope.allProductsPriceChanged && !$scope.heldProducts);
                } else {
                    $scope.allProductsPriceChanged = false;
                    $scope.allProductsChanged = $scope.allProductsAreUnavailable;
                }

                const areSeatsPriceChanged = priceChangedSeats.length;
                const areProductsPriceChanged = !!$scope.avlblData.PriceChangedProducts.length;

                $scope.changedPrices = areProductsPriceChanged || areSeatsPriceChanged;

                $scope.showWarning = ($scope.changedPrices && !$scope.tripData.isApproved) || $scope.hasUnavailableProducts;

                if (!$scope.showWarning) {
                    proceed();
                }
            });
    }

    function allFlightsAreUnavailable(unavailableProducts) {
        if (!unavailableProducts || unavailableProducts.length === 0) {
            return false;
        }

        const {Flights: flights} = $scope.tripDetails;
        const unavailableFlightsCount = unavailableProducts.filter((prod) => prod.TripItemType === tripItemTypes.flight).length;
        return flights.length === unavailableFlightsCount;
    }

    function tripHasHeldProductsWithPriceChanged(tripDetails, priceChangedProducts) {
        const priceChangedProductsIds = priceChangedProducts
            .filter(({TripItemType}) => [tripItemTypes.flight, tripItemTypes.eurostar].includes(TripItemType))
            .map(({TripItemId}) => TripItemId);

        if (!priceChangedProductsIds.length) {
            return false;
        }

        return tripDetails.Flights
            .some(({Status, Id}) => Status === tripStatuses.HELD && priceChangedProductsIds.includes(Id));
    }

    /**
     * Combine unavailable product with PriceChangedProducts in one array with same format like
     * [{TripItemId:productID, TripItemType:productType},...]
     */
    function combineProducts(data) {
        const arr = _.map(data.UnavailableProducts, function(el) {
            return {TripItemId: el.TripItemId, TripItemType: el.TripItemType};
        });

        return _.union(arr, data.PriceChangedProducts);
    }

    /**
     * Change state in dependence of changed product's priority
     */
    function changeState() {
        const arr = combineProducts($scope.avlblData);
        const topItem = Math.min(...arr.map(({TripItemType = 4}) => TripItemType));

        const stateToNavigate = topItem
            ? TRIP_STATES_MAP[topItem]
            : TRIP_STATES_MAP['1'];

        $state.go(stateToNavigate);
    }

    function checkIfAllProductsAreUnavailable() {
        const prodAmount = $scope.tripDetails.Flights.length + $scope.tripDetails.Hotels.length
            + $scope.tripDetails.Cars.length + $scope.tripDetails.Rails.length + $scope.tripDetails.EuRails.length;
        return prodAmount === $scope.unavailableProductsAmount;
    }

    function onlySeatsPriceWasChanged() {
        return $scope.avlblData.PriceChangedSeats.length
            && !$scope.avlblData.PriceChangedProducts.length;
    }

    function checkIfallProductsPriceChanged() {
        const prodAmount = $scope.tripDetails.Flights.length + $scope.tripDetails.Hotels.length
            + $scope.tripDetails.Cars.length + $scope.tripDetails.Rails.length + $scope.tripDetails.EuRails.length;
        return prodAmount === $scope.avlblData.PriceChangedProducts.length;
    }

    function tripHasHeldProducts(trip) {

        /**
         * Check flights and Rails only, since Cars and Hotel can't be held
         */
        if (trip.Status === 'Held') {
            const isFlightHeld = _.some(trip.Flights, function(i) {
                // TODO: get rid of i.Status type mutation
                return i.Status === 2 || i.Status === 'Held';
            });

            const isRailHeld = _.some(trip.Rails, function(i) {
                // TODO: get rid of i.Status type mutation
                return i.Status === 2 || i.Status === 'Held';
            });
            return isFlightHeld || isRailHeld;
        }
        return false;
    }

    /**
     * Set form in pristine state and continue booking
     */
    function proceed() {
        $scope.checkoutForm.$setUntouched();
        $scope.checkoutForm.$setPristine();
        $scope.showWarning = false;
        $rootScope.$broadcast(tripEvents.TRIP_CHECKOUT_BUTTON_START, $scope.nextStep);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/tripCheckoutAvailabilityController.js